import {resolveImageInstance} from "../../../lib/fabric-helper";

export const ID_GROUP_MASK = 'group-mask';

const handleSpecificSelection = function (event) {
    const canvas = event.target.canvas

    const activeObject = canvas.getActiveObject()

    if (activeObject && activeObject.__corner) {
        return;
    }

    const finder = (parent) => {
        const objects = parent
            .getObjects()
            .sort((a, b) => a.order < b.order ? -1 : 1)
            .filter(({specificType}) => specificType !== 'technic');

        for (const target of objects) {
            if (target.type === 'group') {
                const found = finder(target)
                if (found) {
                    return
                } else {
                    continue
                }
            }

            const pointer = event.pointer;

            const matrix = [...target.calcTransformMatrix()]

            const top = matrix.pop()
            const left = matrix.pop()

            const halfWidth = target.getScaledWidth() / 2;
            const halfHeight = target.getScaledHeight() / 2

            const widthCondition = pointer.x > left - halfWidth && pointer.x < left + halfWidth;
            const heightCondition = pointer.y > top - halfHeight && pointer.y < top + halfHeight;

            if (widthCondition && heightCondition) {
                canvas.setActiveObject(target)
                canvas._setupCurrentTransform(event, target, true)
                canvas.requestRenderAll()
                return true
            }
        }
    }
    finder(canvas)
}

export const maskFabricBuilder = async (masks) => {
  return Promise.all(
    masks.map(async (m) => {
      const mask = m.mask;
      const imgInstance = await resolveImageInstance(mask.image);

      imgInstance.set({
        left: mask.left || 0,
        top: mask.top || 0,
        scaleX: mask.scaleX || 1,
        scaleY: mask.scaleY || 1,
        selectable: false,
        evented: false,
        customId: 'maskInstance',
      });

      return imgInstance;
    })
  ); 
};
